module.exports = __webpack_public_path__ + "static/media/Mic32BoldRegular.daf8c280.ttf";